import { Badge, Box, Flex, HStack, Text } from "@chakra-ui/react";
import { FaBicycle, FaCar, FaChevronRight, FaWalking } from "react-icons/fa";
import { MdDirectionsTransit } from "react-icons/md";
import { useUITheme } from "../../context/ThemeContext";

const MODE_DETAILS = {
  walking: { label: "Walk", icon: FaWalking, color: "#4285f4" },
  bicycling: { label: "Cycle", icon: FaBicycle, color: "#0d9488" },
  transit: { label: "Public", icon: MdDirectionsTransit, color: "#7c3aed" },
  driving: { label: "Taxi", icon: FaCar, color: "#ea580c" },
};

const stopName = (stop, fallback) => stop?.name || stop?.formatted_address || fallback;

export default function TransportItinerary({ combinedStops = [], routeLegs = [], onSelectLeg }) {
  const theme = useUITheme();
  if (!routeLegs.length) return <Text opacity={0.65}>Transport details are not available for this itinerary.</Text>;

  return <Box>{routeLegs.map((leg, index) => {
    const details = MODE_DETAILS[leg?.mode] || MODE_DETAILS.walking;
    const Icon = details.icon;
    const from = index === 0 ? "Start" : stopName(combinedStops[index - 1], `Stop ${index}`);
    const to = index < combinedStops.length ? stopName(combinedStops[index], `Stop ${index + 1}`) : "Finish";
    const transitStep = leg?.steps?.find((step) => step.line || step.vehicle);
    return <Box as="button" type="button" key={`${index}-${leg?.mode || "walking"}`} onClick={() => onSelectLeg?.(index)} display="block" w="100%" textAlign="left" border={`1px solid ${theme.accent}`} bg={`${theme.accent}0D`} borderRadius="2xl" px={4} py={3.5} mb={3} transition="transform 0.15s ease, box-shadow 0.15s ease" _hover={{ transform: "translateY(-1px)", boxShadow: "md" }} _focusVisible={{ outline: `3px solid ${theme.primary}`, outlineOffset: "2px" }}>
      <Flex align="center" gap={3}>
        <Box flexShrink={0} boxSize="44px" borderRadius="full" bg={details.color} color="white" display="grid" placeItems="center"><Icon size="19px" /></Box>
        <Box flex="1" minW={0}>
          <HStack spacing={2} mb={0.5}><Text fontSize="xs" fontWeight="extrabold" color={details.color} letterSpacing="0.1em">LEG {index + 1}</Text><Badge borderRadius="full" color="white" bg={details.color}>{details.label}</Badge></HStack>
          <Text fontSize="sm" fontWeight="extrabold" noOfLines={1}>{from} → {to}</Text>
          <Text fontSize="sm" opacity={0.68}>{leg?.duration || "—"} · {leg?.distance || "—"}</Text>
          {transitStep && <Text mt={1} fontSize="xs" fontWeight="semibold" color={details.color} noOfLines={1}>{transitStep.vehicle ? `${transitStep.vehicle} · ` : ""}{transitStep.line}</Text>}
        </Box>
        <FaChevronRight color={theme.primary} aria-hidden="true" />
      </Flex>
    </Box>;
  })}</Box>;
}
